(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gonz-nz-header-shell"]) return;
  try {
    
(() => {
  const initialise = (root) => root.querySelectorAll('.nz2-shell').forEach((shell) => {
    if (shell.dataset.ready) return;
    shell.dataset.ready = 'true';
    shell.querySelectorAll('.nz2-nav__group').forEach((group) => group.addEventListener('toggle', () => {
      if (group.open) group.parentElement.querySelectorAll('.nz2-nav__group').forEach((other) => {
        if (other !== group) other.open = false;
      });
    }));
    shell.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const open = event.target.closest('details[open]');
        if (open) {
          open.open = false;
          open.querySelector('summary')?.focus();
          event.stopPropagation();
        }
      }
    });
    document.addEventListener('click', (event) => {
      if (!shell.contains(event.target)) shell.querySelectorAll('details[open]').forEach((item) => item.open = false);
    });
  });
  initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gonz-nz-homepage"] && !Shopify.designMode) return;
  try {
    
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialise = (root = document) => {
    root.querySelectorAll('[data-nz2-rail]').forEach(shell => {
      if(shell.dataset.ready) return;
      shell.dataset.ready = 'true';
      const track = shell.querySelector('[data-nz2-track]');
      const prev = shell.querySelector('[data-nz2-prev]');
      const next = shell.querySelector('[data-nz2-next]');
      if(!track || !prev || !next) return;
      const interval = Number(shell.dataset.nz2Autoplay || 0);
      let timer = 0;
      const update = () => {
        const end = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft < 3;
        next.disabled = track.scrollLeft > end - 3;
      };
      const move = direction => {
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        track.scrollBy({left:direction * step,behavior:motion.matches?'auto':'smooth'});
      };
      const stop = () => {
        window.clearInterval(timer);
        timer = 0;
      };
      const advance = () => {
        if(document.hidden || motion.matches || track.scrollWidth <= track.clientWidth + 3) return;
        const end = track.scrollWidth - track.clientWidth;
        if(track.scrollLeft > end - 3) {
          track.scrollTo({left:0,behavior:'smooth'});
        } else {
          move(1);
        }
      };
      const start = () => {
        stop();
        if(interval > 0 && !motion.matches && track.scrollWidth > track.clientWidth + 3) {
          timer = window.setInterval(advance, interval);
        }
      };
      prev.addEventListener('click',() => {
        stop();
        move(-1);
        start();
      });
      next.addEventListener('click',() => {
        stop();
        move(1);
        start();
      });
      track.addEventListener('scroll',update,{passive:true});
      shell.addEventListener('mouseenter',stop);
      shell.addEventListener('mouseleave',start);
      shell.addEventListener('focusin',stop);
      shell.addEventListener('focusout',event => {
        if(!shell.contains(event.relatedTarget)) start();
      });
      track.addEventListener('touchstart',stop,{passive:true});
      track.addEventListener('touchend',start,{passive:true});
      document.addEventListener('visibilitychange',() => {
        if(document.hidden) stop();
        else start();
      });
      motion.addEventListener('change',start);
      new ResizeObserver(() => {
        update();
        start();
      }).observe(track);
      update();
      start();
    });
  };
  initialise(); document.addEventListener('shopify:section:load',event=>initialise(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
